import React from 'react'
import { ControlledTooltip, Button, Heading, Label } from 'views/components'
import { $TSFixMe } from 'types/ts-migrate'
import styles from './ChatBot.module.scss'

type TProps = {
  actions?: {
    text?: string
    className?: string
    disabled?: boolean
    action?: () => void
  }[]
  children?: React.ReactNode
  step: string
  displayStep?: boolean
  isStepOptional?: boolean
  title: string
  displayTitleAction?: boolean
  titleActionText?: string
  titleActionDisabled?: boolean
  description?: string
  displayDescription?: boolean
  actionClickHandler: (action: $TSFixMe) => void
  titleActionClickHandler?: () => void
}

const ChatBot = ({
  actions,
  children,
  step,
  displayStep = true,
  isStepOptional = false,
  title,
  displayTitleAction = false,
  titleActionText,
  titleActionDisabled = false,
  description,
  displayDescription = true,
  actionClickHandler,
  titleActionClickHandler,
}: TProps): null | React.ReactElement => {
  return (
    <div className={styles.root}>
      <div className={styles.container}>
        {displayStep && step && isStepOptional ? (
          <span className={styles['step--with-optional']}>
            Step {step}{' '}
            <Label circular className={styles.optional}>
              Optional
            </Label>
          </span>
        ) : displayStep && step ? (
          <span className={styles.step}>Step {step}</span>
        ) : null}
        {title && displayTitleAction ? (
          <div className={styles['title-container']}>
            <Heading as="h2" className={styles.title}>
              {title}
            </Heading>
            <ControlledTooltip body={titleActionText} place="above">
              <Button
                ghost
                className={styles.add}
                onClick={() => titleActionClickHandler && titleActionClickHandler()}
                disabled={titleActionDisabled}
              />
            </ControlledTooltip>
          </div>
        ) : (
          <Heading as="h2" className={styles.title}>
            {title}
          </Heading>
        )}
        {displayDescription && description && <p className={styles.description}>{description}</p>}
        {children && <div className={styles.body}>{children}</div>}
        {actions && (
          <div className={styles.actions}>
            {actions.map((a: any, i: any) => (
              <div className={styles.action} key={i}>
                <Button
                  className={a.className ? styles[a.className] : undefined}
                  disabled={a.disabled}
                  onClick={() => !a.disabled && actionClickHandler(a.action)}
                >
                  {a.text}
                </Button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export default ChatBot
